import React, { useState } from "react";
import Icon from "../utils/icons";
import { money } from "../utils/formatters";

// Remembered for this browser tab only, so a shopper who minimised the bar doesn't see it pop open on every page
const MIN_KEY = "oz_cart_minimised";
const readMinimised = () => {
    try {
        return sessionStorage.getItem(MIN_KEY) === "1";
    } catch {
        return false;
    }
};

// Floating cart bar on the browsing pages, shown once something is in the cart. The shopper can minimise it to a
// small bag bubble (bottom left) and expand it again.
// The total uses the prices last loaded; the cart and checkout show the final amount.
export default function FloatingCart({ items, onOpen }) {
    const [minimised, setMinimisedState] = useState(readMinimised);
    const count = items.reduce((sum, item) => sum + item.qty, 0);
    if (!count) return null;
    const total = items.reduce((sum, item) => sum + item.price * item.qty, 0);
    const label = `${count} item${count === 1 ? "" : "s"}`;

    const setMinimised = (value) => {
        setMinimisedState(value);
        try {
            sessionStorage.setItem(MIN_KEY, value ? "1" : "0");
        } catch {
            /* private mode: only this page remembers */
        }
    };

    // keyed by the count so the icon bounces each time something is added
    const bag = (
        <span className="floatingCartIcon" key={count}>
            <Icon.Bag />
            <b>{count}</b>
        </span>
    );

    if (minimised) {
        return (
            <div className="floatingCart isMinimised">
                <button type="button" className="floatingCartBubble" onClick={() => setMinimised(false)} aria-label={`Show cart bar: ${label}, ${money(total)}`}>
                    {bag}
                </button>
                <button type="button" className="floatingCartToggle" onClick={() => setMinimised(false)} aria-label="Maximise cart bar" title="Maximise">
                    <Icon.ArrowsAngleExpand />
                </button>
            </div>
        );
    }

    return (
        <div className="floatingCart">
            <button type="button" className="floatingCartMain" onClick={onOpen} aria-label={`View cart: ${label}, ${money(total)}`}>
                {bag}
                <span className="floatingCartText">
                    <small>{label}</small>
                    <strong>{money(total)}</strong>
                </span>
                <span className="floatingCartGo">
                    View cart <Icon.ChevronRight />
                </span>
            </button>
            <button type="button" className="floatingCartToggle" onClick={() => setMinimised(true)} aria-label="Minimise cart bar" title="Minimise">
                <Icon.ChevronDown />
            </button>
        </div>
    );
}
